// extracted by mini-css-extract-plugin
export default {"footer":"SiteFooter_footer__maqZQ","link":"SiteFooter_link__P31lI"};